export default "__VITE_ASSET__7tAGoGsd__"